import { ApolloError } from '@apollo/client';

import type { SubmitFormIntent } from '../constants';

export const DUPLICATE_HANGING_PROTOCOL_NAME_CODE = 'DUPLICATE_HANGING_PROTOCOL_NAME';

export const isUniqueNameError = (err: unknown): boolean => {
  if (!(err instanceof ApolloError)) return false;
  return err.graphQLErrors.some((e) => e.extensions?.code === DUPLICATE_HANGING_PROTOCOL_NAME_CODE);
};

export const getHangingProtocolErrorMessage = (
  err: unknown,
  mode: Nullable<SubmitFormIntent>
): string => {
  const action = mode ?? 'save';

  if (isUniqueNameError(err)) {
    return `Failed to ${action} hanging protocol. Hanging protocol must have a unique name.`;
  }

  return `Failed to ${action} hanging protocol.`;
};
